export enum MentoringRequestStatus {
    PENDING = 'PENDING',
    MANAGER_DECLINED = 'MANAGER_DECLINED',
    MANAGER_APPROVED = 'MANAGER_APPROVED',
    MENTOR_DECLINED = 'MENTOR_DECLINED',
    MENTOR_APPROVED = 'MENTOR_APPROVED',
    CLOSED = 'CLOSED'
}